const initialState = {
    searchAlarmValue:[],
};
export const actionTypes = {
    SEARCH_ALARM_TABLE:"SEARCH_ALARM_TABLE",
};

export const actions = {
    search_alarm_table: function (data) {
        return {
            type: actionTypes.SEARCH_ALARM_TABLE,
            data
        }
    }
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.SEARCH_ALARM_TABLE:{
            return {...state,searchAlarmValue:action.data}
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/alarmReducer.js